import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { CoverLetterSubmissionNotes } from '../../cmg-1003/models/cover-letter-submission-notes.model';
import { iStoreActions } from '../core/store-actions.interface';

function createInitialState(): CoverLetterSubmissionNotes {
  return <CoverLetterSubmissionNotes>{};
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'cmg-1003-cover-letter-submissions-store' })
export class Cmg1003CoverLetterSubmissionsStore extends Store<CoverLetterSubmissionNotes> implements iStoreActions<CoverLetterSubmissionNotes> {
  constructor() {
    super(createInitialState());
  }

  preInitialize(coverLetterSubmissionNotes: CoverLetterSubmissionNotes): void {
    this.update(coverLetterSubmissionNotes);
  }
}
